<template>
    <form @submit.prevent="StoreData" method="post" @input="saveState">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="card mb-3 shadow">
                    <div class="card-header bg-gradient-primary">
                        <h4 class="card-title text-white">Pemohon</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label>Nama</label>
                            <input type="text" class="form-control" :class="errors.nama ? 'is-invalid' : ''" v-model="data.nama">
                            <div class="invalid-feedback">{{ errors.nama }}</div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Intansi / Perusahaan</label>
                            <input type="text" class="form-control" :class="errors.instansi ? 'is-invalid' : ''" v-model="data.instansi">
                            <div class="invalid-feedback">{{ errors.instansi }}</div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Alamat</label>
                            <input type="text" class="form-control" :class="errors.alamat ? 'is-invalid' : ''" v-model="data.alamat">
                            <div class="invalid-feedback">{{ errors.alamat }}</div>
                        </div>
                        <div class="form-group mb-3">
                            <label>No Telepon / Hp</label>
                            <input type="text" class="form-control" :class="errors.nohp ? 'is-invalid' : ''" v-model="data.nohp">
                            <div class="invalid-feedback">{{ errors.nohp }}</div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Tanggal</label>
                            <input type="date" class="form-control" :class="errors.tanggal ? 'is-invalid' : ''" v-model="data.tanggal">
                            <div class="invalid-feedback">{{ errors.tanggal }}</div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Paket Pekerjaan</label>
                            <input type="text" class="form-control" :class="errors.paket_pekerjaan ? 'is-invalid' : ''" v-model="data.paket_pekerjaan">
                            <div class="invalid-feedback">{{ errors.paket_pekerjaan }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="card mb-3 shadow">
                    <div class="card-header bg-gradient-primary">
                        <h4 class="card-title text-white">Pengujian</h4>
                    </div>
                    <div class="card-body">
                        <div v-for="(kategori, kategori_id) in formsData.kategori" v-bind:key="kategori">
                            <div class="fw-bold">{{ kategori }}</div>
                            <div v-for="subkategori in formsData.subkategori" v-bind:key="subkategori">
                                <div v-if="subkategori.kategori_id == kategori_id" class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="formsData.checked[subkategori.id]">
                                    <label class="custom-control-label">{{ subkategori.nama }}</label>
                                    <div v-if="formsData.checked[subkategori.id]">
                                        <div class="form-group mb-1">
                                            <label>Jumlah</label>
                                            <input type="number" class="form-control" v-model="usulan[subkategori.id].jumlah">
                                        </div>
                                        <div class="form-group mb-1" v-for="keterangan in formsData.form[subkategori.id]" v-bind:key="keterangan">
                                            <label class="text-capitalize">{{ keterangan.form.replaceAll('_', ' ') }}</label>
                                            <input :type="keterangan.form.includes('tgl') ? 'date' : 'text'" class="form-control" v-model="usulan[subkategori.id].keterangan[keterangan.form]">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <button type="sumit" class="btn bg-gradient-primary">Simpan</button>
        </div>
    </form>

</template>

<script>

export default {
    name: "UjilabPengajuanIndex",
    data() {
        return {
            data: {
                status: 'Pengajuan'
            },
            usulan: {},
            formsData: {
                checked: [],
                form: {}
            },
            errors: {},
        }
    },
    methods: {
        saveState() {
            this.data.usulan = {};
            setTimeout(() => {
                Object.keys(this.formsData.checked).forEach((value) => {
                    if (this.formsData.checked[value]) {
                        this.data.usulan[value] = this.usulan[value];
                    }
                });
            }, 100);
        },
        StoreData() {
            const self = this;
            this.axios.post('pengajuan', this.data).then((response) => {
                if (response.data.error) {
                    this.errors = response.data.message;
                } else {
                    this.$swal.fire({
                        icon: 'success',
                        title: response.data.message,
                        text: `Kode Tracking : ${response.data.data.kode_tracking}`,
                    }).then(function () {
                        self.$router.push({ name: 'auth.guest' });
                    });
                }
            });
        }
    },
    mounted() {
        this.axios.get('kategori-select').then((response) => {
            this.formsData.kategori = response.data;
        });
        this.axios.get('subkategori-list').then((response) => {
            response.data.data.forEach((row) => {
                this.formsData.form[row.id] = JSON.parse(row.keterangan.replaceAll('&quot;', '"'));
                this.usulan[row.id] = {
                    kategori_id: row.kategori_id,
                    subkategori_id: row.id,
                    jumlah: '',
                    keterangan: {},
                    status: 'Pengajuan'
                };
            });
            this.formsData.subkategori = response.data.data;
        });
    }
}
</script>